import { get, post } from '../../utils/api';

import { BASE_API_AUTH } from 'utils/constants';
import { DataResponse } from '../response';
import { HistoryLogIn } from 'services/Main/common_services';

// ===================== User Model =============================//
// module
export type ModuleModel = {
  moduleId: string;
  moduleName: string;
  icon: string;
  isSystemModule: boolean;
  orderIndex: number;
  imageUrl: string;
  description: string;
  details: string;
  url: string;
  rowIndex: number;
  error: any;
  isNullValueId: boolean;
  menuId: string;
  menuName: string;
  menuModel: MenuModel2[]
  activedMenuList: any;
  pageList: any;
  activedPageList: any;
  pageId: string;
  pageName: string;
}

export interface MenuModel2 {
  menuId: string
  menuName: string
  moduleId: string
  icon: string
  orderIndex: number
  pageViewModels: PageViewModel[]
  rowIndex: number
  error: any
  isNullValueId: boolean
  isChooseAll: any
}

export interface PageViewModel {
  pageId: string
  pageName: string
  pageUrl: string
  icon: any
  parameter?: string
  moduleId: string
  menuId: string
  orderIndex: number
  isChooseAll: any
  domainConfig: any
  domainConfigUrl?: string
}

// Menu con // submenu
export type ChildMenu = {
  menuId: string;
  icon: string;
  pageName: string;
  pageId: string;
  pageUrl: string;
  domainConfigUrl: string;
  domainConfig: number;
  parameter: string;
};

export type Menu = {
  menuId: string;
  icon: string;
  menuName: string;
};
export interface PagePermissionModel {
  pageId: string;
  functionId: string;
}
export type WebPermission = {
  menuModel: Menu[];
  pageModel: ChildMenu[];
  pagePermissionModel: PagePermissionModel[];
  moduleModel: ModuleModel[]
};


// user
export type User = {
  accountId: string;
  token: string;
  userName: string;
  employeeCode: string;
  fullName: string;
  validaty: string;
  refreshToken: string;
  companyId: string;
  role: string;
  roleName: string;
  roles: string;
  expiredTime: Date;
  webPermission: WebPermission;
  plantCode: string;
  plantName: string;
  saleOrgCode: string;
  saleOrgName: string;
  isShowDashboard: boolean;
  isShowChooseModule: boolean;
  isResetPassword: boolean;
  isSupplier: boolean;
  qrCode: string;
  isAuthenticate: boolean;
  vendorCode?: string;
  vendorName?: string;

};

export interface KeyAndValue {
  key: string;
  value: string
}
export interface CompanyByUsername {
  isLogAuthen: boolean;
  listCompany: KeyAndValue[]
}
// interface của user service
// Khai báo phương thức
export interface IUserServices {
  // Đăng nhập
  login(data: any): Promise<DataResponse<User>>;
  // danh sách company by username
  getCompanyByUsername(username: string): Promise<DataResponse<CompanyByUsername>>
  // danh sách saleorg by username
  getSaleorgByUsername({ companyCode, username }: { username: string; companyCode: string }): Promise<DataResponse<KeyAndValue[]>>
  // Xác thực OTP
  confirmOTP(data: { userName: string; otp: string, saleOrg: string }): Promise<DataResponse<User>>;
  getLogLogIn(data: object): Promise<DataResponse<Array<HistoryLogIn>>>;
  getLogOutDeviceId(deviceId: string, username: string): Promise<DataResponse<any>>;
  getLogOut(devicedId: string, isAdminLogout: boolean): Promise<DataResponse<any>>;
  logOutAllDevice(deviceIds: string[]): Promise<DataResponse<any>>;
  getSummaryLogLogin(username: string): Promise<DataResponse<any>>;
}
// Hàm khởi tạo các phươn thức của user service
export function createUserServices(): IUserServices {
  return {
    login: async (data: any): Promise<DataResponse<User>> => {
      return (await post(process.env.REACT_APP_BASE_API + '/api/v1', `auth/login`, data)).data;
    },
    // danh sách company by username
    getCompanyByUsername: async (username) => {
      return (await get(BASE_API_AUTH, `auth/get-company-by-username/${username}`)).data;
    },
    // danh sách saleorg by username
    getSaleorgByUsername: async ({ username, companyCode }) => {
      return (await get(BASE_API_AUTH, `auth/get-saleorg-by-username/${username}?companyCode=${companyCode}`)).data;
    },
    // Xác thực OTP
    confirmOTP: async (data) => {
      return (await post(BASE_API_AUTH, `auth/confirm-otp`, data)).data;
    },
    getLogLogIn: async (data) => {
      return (await post(BASE_API_AUTH, `auth/get-log-login`, data)).data;
    },
    getLogOutDeviceId: async (deviceId, username) => {
      return (await get(BASE_API_AUTH, `auth/logout-deviceid/${deviceId}_${username}`)).data;
    },
    getLogOut: async (deviceId, isAdminLogout) => {
      return (await get(BASE_API_AUTH, `auth/logout?deviceId=${deviceId}&isAdminLogout=${isAdminLogout}`)).data;
    },
    logOutAllDevice: async (deviceIds) => {
      return (await post(BASE_API_AUTH, `auth/logout-all-device`, { deviceIds })).data;
    },
    getSummaryLogLogin: async (username) => {
      return (await get(BASE_API_AUTH, `auth/get-summary-log-login/${username}`)).data;
    }
  };
}
